import { DefaultQueryClientProvider } from '@opallabs/higgs'
import { ThemeProvider } from '@opallabs/hooks'
import { SidebarStatus, SidebarStatusProps } from '.'

export const QueryableSidebarStatus: React.FC<SidebarStatusProps> = (props) => (
  <DefaultQueryClientProvider>
    <ThemeProvider theme="dark">
      <SidebarStatus {...props} />
    </ThemeProvider>
  </DefaultQueryClientProvider>
)
